import React, { useReducer, useState } from "react";
import PropTypes from "prop-types";
import { Button, Input, message, Modal, Card, Flex } from "antd";
import * as XLSX from "xlsx";
import { useFetch } from "../../../Utils/useFetch";
import { FETCH_ALL_ALERTWARNING_API } from "../../../Constants/Apis";
import { reducer } from "../../../Utils/CommonUtils";
import AlertReportTable from "../../elements/Tables/AlertReportTable/AlertReportTable";
import { deleteAlertWarning } from "../../../Services/AlertWarningService";

const { Search } = Input;

const AlertReportPage = ({ history }) => {
  const initialState = {
    searchKeyword: "",
    filteredInfo: {},
    sorter: {},
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const {
    fetchedData: { data: alertData = [] },
    callReFetch,
    loading,
  } = useFetch(`${FETCH_ALL_ALERTWARNING_API}/stock-quantity/ECOMMRI`, state);

  const handleSearch = (value) => {
    dispatch({ type: "searchKeyword", payload: value });
    callReFetch();
  };

  const handleExport = () => {
    if (!alertData?.length) {
      message.warning("No data to export");
      return;
    }

    const formattedData = alertData.map((item) => ({
      "Counter Code": item.counterCode,
      SKU: item.sku,
      Barcode: item.barcode,
      "Article Name": item.article,
      Color: item.color,
      Threshold: item.threshold,
      "Total Quantity": item.totalQuantity,
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "AlertReport");
    XLSX.writeFile(workbook, "AlertReport.xlsx");
  };

  const handleDelete = async () => {
    try {
      await deleteAlertWarning(selectedId);
      message.success("Alert warning deleted");
      setIsModalOpen(false);
      callReFetch();
    } catch (err) {
      message.error("Failed to delete alert warning");
    }
  };

  return (
    <div
      style={{
        width: "100%",
        padding: "20px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        overflowX: "hidden",
      }}
    >
      <h1>Alert Warning Report</h1>

      <div
        style={{
          paddingBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          maxWidth: "1200px",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <Flex gap="small">
          <Button type="default" onClick={handleExport}>
            Export to Excel
          </Button>
          <Search
            placeholder="Search by SKU or counter..."
            allowClear
            onSearch={handleSearch}
            style={{ width: "300px" }}
          />
        </Flex>
      </div>

      <AlertReportTable
        history={history}
        loading={loading}
        data={alertData}
        callReFetch={callReFetch}
        dispatch={dispatch}
        handleDelete={(id) => {
          setSelectedId(id);
          setIsModalOpen(true);
        }}
      />

      <Modal
        title="Delete Alert Warning"
        open={isModalOpen}
        onOk={handleDelete}
        onCancel={() => setIsModalOpen(false)}
      >
        <p>Are you sure you want to delete this alert warning?</p>
      </Modal>
    </div>
  );
};

AlertReportPage.propTypes = {
  history: PropTypes.object,
};

export default AlertReportPage;
